/**
 * It checks if two collections are different by comparing their objects' UUIDs.
 */
export function areCollectionsDifferentByUuid(
  collection1: { uuid: string }[],
  collection2: { uuid: string }[]
): boolean {
  if (collection1.length !== collection2.length) {
    return true
  }

  const uuids1 = collection1.map((item) => item.uuid).sort()
  const uuids2 = collection2.map((item) => item.uuid).sort()

  return !uuids1.every((uuid, index) => uuid === uuids2[index])
}
